import type { GlobalToken } from 'antd';
import type React from 'react';

import { css } from 'config/emotionCss';

import type { ListSize } from './types';

export const LISTY_WRAPPER_CLASS = 'legacy-listy-wrapper';

export const ITEM_CLASS = 'legacy-list-item';

export const HEADER_CLASS = 'legacy-list-header';

export const listyItemInlineStyle: React.CSSProperties = {
  padding: 0,
  borderBottomWidth: 0,
  backgroundColor: 'transparent',
};

export const loadingPlaceholderStyle = css`
  min-height: 53px;
`;

const getItemPadding = (token: GlobalToken, size: ListSize) => {
  if (size === 'small') {
    return `${token.paddingContentVerticalSM}px ${token.paddingContentHorizontal}px`;
  }

  if (size === 'large') {
    return `${token.paddingContentVerticalLG}px ${token.paddingContentHorizontalLG}px`;
  }

  return `${token.paddingContentVertical}px 0`;
};

export const getRootStyle = (token: GlobalToken, size: ListSize) => css`
  position: relative;
  box-sizing: border-box;
  font-family: ${token.fontFamily};
  color: ${token.colorText};
  font-size: ${token.fontSize}px;
  line-height: ${token.lineHeight};

  & * {
    outline: none;
  }

  .${ITEM_CLASS} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${getItemPadding(token, size)};
    color: ${token.colorText};
    border-block-end: ${token.lineWidth}px ${token.lineType} ${token.colorSplit};
  }

  .${LISTY_WRAPPER_CLASS}:last-child > .${ITEM_CLASS} {
    border-block-end: none;
  }
`;

export const getHeaderStyle = (token: GlobalToken) => css`
  padding-block: ${token.paddingSM}px;
  border-block-end: ${token.lineWidth}px ${token.lineType} ${token.colorSplit};
`;

export const getEmptyTextStyle = (token: GlobalToken) => css`
  padding: ${token.padding}px;
  color: ${token.colorTextDisabled};
  font-size: ${token.fontSize}px;
  text-align: center;
`;
